import { IClientDeviceFeatures } from "./client-device.features.interface";

export class ClientDeviceFeatures implements IClientDeviceFeatures {
}
